import { Link as RemixLink } from "@remix-run/react";
import { Box, Heading, Text, HStack, Link, SimpleGrid } from "@chakra-ui/react";
import { FaShieldAlt, FaBolt, FaGift, FaBullseye } from "react-icons/fa";

function ValueProp({ icon, children }) {
  return (
    <HStack align="start" spacing={3}>
      <Box as={icon} boxSize="18px" color="accent" flexShrink={0} mt={1} />
      <Text color="muted">{children}</Text>
    </HStack>
  );
}

/**
 * "Sold out doesn't mean forever" — the why-cancellations explainer shared by
 * the homepage and every country landing page. Copy is intentionally
 * agency-agnostic so one component serves every variant (replaces the old
 * per-config AboutSection on country pages).
 */
export function WhyCancellations() {
  return (
    <Box p={{ base: 4, md: 0 }} maxW="container.md" mx="auto" w="100%">
      <Box textAlign="center" mb={{ base: 6, md: 8 }}>
        <Heading
          as="h2"
          size={{ base: "sm", md: "md" }}
          fontWeight="extrabold"
          mb={4}
        >
          Sold out doesn&rsquo;t mean forever
        </Heading>
        <Text fontSize={{ base: "md", md: "lg" }} color="muted">
          Plans change, and when they do, that sold-out site drops right back
          into the public reservation system.{" "}
          <Text as="strong" color="emphasized">
            Schnerp just makes sure you hear about it first.
          </Text>
        </Text>
      </Box>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={5} fontSize="md">
        <ValueProp icon={FaBullseye}>
          <Text as="strong" color="emphasized">
            No false alarms.
          </Text>{" "}
          Every alert is a real, bookable spot. We check minimum stays, check-in
          gaps, and each system&rsquo;s rules before we ever notify you.
        </ValueProp>
        <ValueProp icon={FaBolt}>
          <Text as="strong" color="emphasized">
            First to know.
          </Text>{" "}
          The best cancellations get snapped up fast, so we watch around the
          clock and send the moment one opens. No one gets you there sooner.
        </ValueProp>
        <ValueProp icon={FaShieldAlt}>
          <Text as="strong" color="emphasized">
            We alert, you book.
          </Text>{" "}
          You book directly through the parks agency. We never book on your
          behalf.
        </ValueProp>
        <ValueProp icon={FaGift}>
          <Text as="strong" color="emphasized">
            Free to start.
          </Text>{" "}
          10 free notifications, no credit card required.{" "}
          <Link as={RemixLink} to="/pricing">
            See upgrade options.
          </Link>
        </ValueProp>
      </SimpleGrid>
    </Box>
  );
}
